import {
  Button, Div,
  Group, Panel, Placeholder, PullToRefresh,
  RichCell, Skeleton,
} from '@vkontakte/vkui';
import { Panels } from '../Consts';
import { PlatformPanelHeader } from '../components/PlatformPanelHeader';
import { useAppContext } from '../../AppContext';
import React, { useEffect, useState } from 'react';
import { Icon20CheckCircleFillGreen, Icon20ClockOutline, Icon20ErrorCircleFillRed, Icon28ScanViewfinderOutline } from '@vkontakte/icons';
import { getRouteScanReceipt } from '../../route';
import { UserAvatar } from '../components/UserAvatar';

const CURRENT_PANEL = Panels.SCAN_RECEIPTS_LIST_PANEL;

const SceletonPanel = () => {
  return (<Panel nav={CURRENT_PANEL} className={'SceletonPanel'}>
    <PlatformPanelHeader
      text={<Skeleton width={170} />}
      isShowBack={false}
    />

    <Group>
      {[1,2,3,4,5,6,7,8,9,10].map((i) => (
        <RichCell
          key={i}
          before={<Skeleton width={24} height={24} borderRadius="50%" />}
          subhead={<Skeleton width={80} />}
          text={<Skeleton width={50} />}
          after={<Skeleton width={24} height={24} borderRadius="50%" />}
          afterCaption={<Skeleton width={30} />}
          caption={<Skeleton width={100} />}
          multiline
        >
        </RichCell>
      ))}
    </Group>
  </Panel>);
}

const ScanReceiptsListPanel = () => {
  const context = useAppContext();
  const params = context.router.getParams();

  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoad, setIsLoad] = useState(false);
  const [isInit, setIsInit] = useState(false);

  const onRefresh = () => {
    setIsLoad(true);
    loadData(0, false)
      .then((response) => {
        setItems([...response.items]);
        setTotalCount(response.total);
      })
      .catch((error) => {
        context.showError(error);
      })
      .finally(() => {
        setIsLoad(false);
      });
  }
  const loadMore = () => {
    fetch(items.length);
  }
  const fetch = (offset) => {
    setIsLoad(true);

    loadData(offset)
      .then((response) => {
        setItems(response.items);
        setTotalCount(response.total);
        setIsLoad(false);
      })
      .catch((error) => {
        context.showError(error);
      })
      .finally(() => {
        setIsLoad(false);
      });
  }

  const loadData = (offset, useCache = true) => {
    return new Promise((resolve, reject) => {
      const cache = {
        items: [],
        total: 0,
      };

      if (useCache === true) {
        const data = context.store.getScanReceiptsCache(params.eventId);
        if (data) {
          cache.items = data.items;
          cache.total = data.total;
          if (cache.items.length > offset) {
            return resolve({
              items: cache.items,
              total: cache.total,
            });
          }
        }
      }

      context.httpClient()
        .getReceipts(params.eventId, offset)
        .then((response) => {
          const itemsList = [...(cache.items || []), ...(response.data.items || [])];
          context.store.setScanReceiptsCache(params.eventId, response.data.total || 0, itemsList);

          return resolve({
            items: itemsList,
            total: response.data.total || 0,
          });
        })
        .catch((error) => {
          return reject(error);
        });
    });
  }

  useEffect(() => {
    context.spinner(isLoad);
  }, [isLoad])
  useEffect(() => {
    setIsLoad(true);
    context.init()
      .then(() => {
        fetch(0);
      })
      .catch((e) => {
        context.showError(e);
      })
      .finally(() => {
        setIsInit(true);
      });
  }, []);

  const getStatusIcon = (status) => {
    if (status === 'error') {
      return <Icon20ErrorCircleFillRed />
    } else if (status === 'wait') {
      return <Icon20ClockOutline />
    }

    return <Icon20CheckCircleFillGreen />;
  }

  const getDescription = (item) => {
    if (item.status !== 'finish') {
      return '';
    }

    return context.lang().declOfNum(CURRENT_PANEL, 'description', item.totalCountItems, '', {
      totalCountItems: item.totalCountItems,
      totalAmount: item.totalAmount,
    });
  }

  if (!isInit) {
    return (<SceletonPanel />);
  }

  return (<Panel nav={CURRENT_PANEL}>
    <PlatformPanelHeader
      text={context.lang().getKey(CURRENT_PANEL, 'header')}
    />
    <PullToRefresh
      onRefresh={onRefresh}
      isFetching={isLoad}
    >
      <Group
        separator={'hide'}
      >
        {
          !isLoad && items.length < 1 && (<Placeholder icon={<Icon28ScanViewfinderOutline />}>
            {context.lang().getKey(CURRENT_PANEL, 'emptyList')}
          </Placeholder>)
        }
        {
          items.map((item) => (<RichCell
              key={item.id}
              before={<UserAvatar type={item.creator.type} size={24} src={item.creator.img} name={item.creator.name} id={item.creator.id} />}
              subhead={item.creator.name}
              text={context.lang().dateFormatShort(item.date)}
              after={getStatusIcon(item.status)}
              afterCaption={context.lang().getKey(CURRENT_PANEL, 'status_label__' + item.status)}
              caption={getDescription(item)}
              multiline
              onClick={() => context.router.push(...getRouteScanReceipt(params.eventId, item.id))}
            >
            </RichCell>))
        }
        {
          totalCount > items.length ? (<Div>
            <Button
              size="s"
              mode="tertiary"
              stretched={true}
              onClick={loadMore}
            >
              {context.lang().getKey(CURRENT_PANEL, 'moreLoadButton')}
            </Button>
          </Div>) : undefined
        }
      </Group>
    </PullToRefresh>
  </Panel>)
}

export default ScanReceiptsListPanel;